import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import RankingsBoxTableCell from './RankingsBoxTableCell'

const RankingsBoxTableDetailsRow = ({
  columns,
  data,
  indicator,
  maxRevenueCurrent,
  maxRevenuePerM2Current,
  maxRevenuePerStoreCurrent,
  maxTrafficCurrent,
}) => {
  const { rank, revenueCurrent, revenuePerM2Current, revenuePerStoreCurrent, trafficCurrent } = data
  const isRankFirst = rank === 1
  const percentOfMax = {
    revenueCurrent: Math.round((100 * revenueCurrent) / maxRevenueCurrent),
    revenuePerM2Current: Math.round((100 * revenuePerM2Current) / maxRevenuePerM2Current),
    revenuePerStoreCurrent: Math.round((100 * revenuePerStoreCurrent) / maxRevenuePerStoreCurrent),
    trafficCurrent: Math.round((100 * trafficCurrent) / maxTrafficCurrent),
  }

  return (
    <div className="rankings-box-table-details-row">
      <div className={classNames('row-wrapper flex-row', { 'rank-first': isRankFirst })}>
        {columns.map(column => {
          if (indicator === column) {
            return null
          }

          return <RankingsBoxTableCell key={column} cellName={column} column={column} percentOfMax={percentOfMax} {...data} />
        })}
      </div>
    </div>
  )
}

RankingsBoxTableDetailsRow.contextTypes = {
  t: PropTypes.func,
}

RankingsBoxTableDetailsRow.defaultProps = {
  columns: [],
}

RankingsBoxTableDetailsRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.object,
  indicator: PropTypes.string,
  maxRevenueCurrent: PropTypes.number,
  maxRevenuePerM2Current: PropTypes.number,
  maxRevenuePerStoreCurrent: PropTypes.number,
  maxTrafficCurrent: PropTypes.number,
}

export default RankingsBoxTableDetailsRow
